import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TPriceGroupDM from './TPriceGroupDM'

export default class TTradingPartnerPriceGroupDM extends Data {
	public static className = 'TTradingPartnerPriceGroupDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	Reduction?: number
	ProductGroupRID?: number
	TradingPartnerId?: number
	RID?: number
	RecordMod?: number
	RecordES?: number
	RecordID?: number
	RecordState?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	@Type(() => TPriceGroupDM)
	PriceGroupId?: TPriceGroupDM
}